module.exports = __webpack_public_path__ + "img/OlhandoPraBaixo_Corpo_1.13d65e66.png";